import script from "./SubMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SubMenu.vue?vue&type=script&setup=true&lang=js"

import "./SubMenu.vue?vue&type=style&index=0&id=32360530&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32360530"]])

export default __exports__